// ✅ src/components/Todo/TodoList.js
import React from "react";
import TodoItem from "./TodoItem";

const TodoList = ({ tasks, onSelectTask, onToggleComplete, onTagClick, onDelete }) => {
  return (
    <div>
      {tasks.map((task) => (
        <TodoItem
          key={task.id}
          task={task}
          onToggleComplete={onToggleComplete}
          onClick={() => onSelectTask(task)}
          onTagClick={onTagClick}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default TodoList;
